const DRY_SKIN = 'Dry skin';
const OILY_SKIN = 'Oily skin';
const OILY_CLASS_ID = 2;

export function normalizeConditionName(name) {
  if (!name || typeof name !== 'string') return name;
  const trimmed = name.trim();
  if (trimmed.toLowerCase() === DRY_SKIN.toLowerCase()) return OILY_SKIN;

  const simplified = trimmed
    .replace(/\([^)]*\)/g, ' ')
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();

  if (
    simplified === 'uneven skintone'
    || simplified === 'unevenskin'
    || simplified === 'uneven skin'
    || simplified === 'uneven tone'
    || simplified === 'even tone'
    || simplified === 'uneven texture'
    || simplified.includes('uneven tone')
    || simplified.includes('even tone')
    || simplified.includes('uneven texture')
    || (simplified.includes('uneven skin') && (simplified.includes('tone') || simplified.includes('texture')))
  ) {
    return 'UnevenSkin';
  }

  return trimmed;
}

export function normalizeDetection(detection) {
  if (!detection || typeof detection !== 'object') return detection;
  const original = detection.class_name || detection.className;
  const normalized = normalizeConditionName(original);
  if (!normalized || normalized === original) return detection;
  return {
    ...detection,
    class_name: normalized,
    className: normalized,
    class_id: OILY_CLASS_ID,
  };
}

export function normalizeDetections(detections) {
  if (!Array.isArray(detections)) return detections;
  return detections.map((d) => normalizeDetection(d));
}

export function mergeNormalizedScores(scoresObj) {
  if (!scoresObj || typeof scoresObj !== 'object') return scoresObj;
  const merged = {};
  Object.entries(scoresObj).forEach(([rawName, rawScore]) => {
    const name = normalizeConditionName(rawName);
    const score = typeof rawScore === 'number' ? rawScore : parseFloat(rawScore);
    if (!Number.isNaN(score)) {
      const existing = merged[name];
      merged[name] = typeof existing === 'number' ? Math.min(existing, score) : score;
      return;
    }
    if (!(name in merged)) merged[name] = rawScore;
  });
  return merged;
}

export function normalizeDescriptionMap(descriptions) {
  if (!descriptions || typeof descriptions !== 'object') return descriptions;
  const out = {};
  Object.entries(descriptions).forEach(([rawName, description]) => {
    const name = normalizeConditionName(rawName);
    if (!(name in out)) out[name] = description;
  });
  return out;
}

export function normalizeSkinScore(skinScore) {
  if (!skinScore || typeof skinScore !== 'object') return skinScore;
  return {
    ...skinScore,
    skin_label_scores: mergeNormalizedScores(skinScore.skin_label_scores),
    condition_scores: mergeNormalizedScores(skinScore.condition_scores),
  };
}
